/**
 * Базовый URL Directus без завершающего слэша.
 * Плейсхолдер нужен при импорте SDK (в т.ч. в клиентских чанках), иначе createDirectus('') бросает Invalid URL.
 * В продакшене задайте DIRECTUS_HOST в окружении.
 */
export function getDirectusHost(): string {
  const raw = process.env.DIRECTUS_HOST?.trim() ?? "";
  if (raw !== "") {
    return raw.replace(/\/$/, "");
  }
  return "http://127.0.0.1:1";
}
